import { request } from "./allauth";

export const DEFAULT_PAGE_SIZE_PLAYLIST_DETAIL = 200;

export async function getOrFetchContent(targetUrl: string) {
  return await request(
    "GET",
    `/api/get-or-fetch-content?target_url=${encodeURIComponent(targetUrl)}`
  );
}

export async function sessionForResourceContent(resourceContentId: string) {
  return await request(
    "GET",
    `/api/session-for-resource-content/${resourceContentId}`
  );
}

export async function addPlaylist(playlistUrl: string) {
  return await request(
    "POST",
    `/api/add-playlist?playlist_url=${encodeURIComponent(playlistUrl)}`
  );
}

export async function getMyPlaylists(
  page: number,
  pageSize: number,
  passSinglePlaylistDetails: boolean = false,
  singlePlaylistItemsPageSize: number = DEFAULT_PAGE_SIZE_PLAYLIST_DETAIL
) {
  return await request(
    "GET",
    `/api/my-playlists?page=${page}&page_size=${pageSize}&pass_single_playlist_details=${passSinglePlaylistDetails}&single_playlist_items_page_size=${singlePlaylistItemsPageSize}`
  );
}

export interface Video {
  id: string;
  title: string;
  description: string;
  thumbnail: string | null;
  thumbnails?: { url: string }[];
  duration: string;
  url: string | null;
}

export interface PlaylistDetail {
  id: string;
  title: string;
  description: string;
  video_count: number;
  videos: Video[];
  created_at: string;
  // Pagination fields
  total?: number;
  total_pages?: number;
  current_page?: number;
  page_size?: number;
  has_next?: boolean;
  has_previous?: boolean;
}

export interface SessionHistoryItem {
  id: string;
  target_url: string;
  title: string;
  thumbnail?: string;
  created_at?: string;
}

export interface SessionHistoryResponse {
  items: SessionHistoryItem[];
  total: number;
  total_pages: number;
  current_page: number;
  has_next: boolean;
  has_previous: boolean;
}

export const getPlaylistDetail = async (
  playlistId: string,
  page: number = 1,
  pageSize: number = DEFAULT_PAGE_SIZE_PLAYLIST_DETAIL
): Promise<PlaylistDetail> => {
  const response = await request(
    "GET",
    `/api/playlist/${playlistId}?page=${page}&page_size=${pageSize}`
  );
  return {
    ...response,
    videos: response.videos || [],
    description: response.description || "",
  };
};

export const refreshPlaylist = async (
  playlistId: string,
  isAutoRefresh: boolean = false,
  page: number = 1,
  pageSize: number = DEFAULT_PAGE_SIZE_PLAYLIST_DETAIL
): Promise<PlaylistDetail> => {
  const response = await request(
    "POST",
    `/api/refresh-playlist/${playlistId}?page=${page}&page_size=${pageSize}`,
    { is_auto_refresh: isAutoRefresh }
  );
  return {
    ...response,
    videos: response.videos || [],
    description: response.description || "",
  };
};

export const getSessionHistory = async (
  page: number = 1,
  pageSize: number = 15
): Promise<SessionHistoryResponse> => {
  const response = await request(
    "GET",
    `/api/session-history?page=${page}&page_size=${pageSize}`
  );
  return {
    ...response,
    items: response.items || [],
  };
};

export interface SeenThreadSummariesResponse {
  success: boolean;
  slugs: string[];
  count: number;
}

export const getSeenThreadSummaries = async (
  resourceId: string,
  mode: "threadInsights" | "threadTimeline"
): Promise<SeenThreadSummariesResponse> => {
  const response = await request(
    "GET",
    `/api/seen-thread-summaries?resource_id=${encodeURIComponent(resourceId)}&mode=${mode}`
  );
  return response;
};
